// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * NOTE: adding new mime types should never change the ordering of 
 * existing mime types in the database. Therefore, if you add a new 
 * mime type, it MUST take another, unique, int value.
 */
export enum EntityMimeTypeIdBuf {
  Unknown = 0,
  ApplicationBc = 1,
  ApplicationClass = 2,
  ApplicationExe = 3,
  ApplicationJavascript = 4,
  ApplicationJson = 5,
  ApplicationMach = 6,
  ApplicationMsgpack = 7,
  ApplicationObj = 8,
  ApplicationOctetStream = 9,
  ApplicationPdf = 10,
  ApplicationWasm = 11,
  ApplicationWwwFormUrlencoded = 12,
  Archive7z = 13,
  ArchiveAr = 14,
  ArchiveBz2 = 15,
  ArchiveCab = 16,
  ArchiveCpio = 17,
  ArchiveCrx = 18,
  ArchiveDcm = 19,
  ArchiveDeb = 20,
  ArchiveGz = 21,
  ArchiveLz = 22,
  ArchiveMsi = 23,
  ArchiveNes = 24,
  ArchivePs = 25,
  ArchiveRar = 26,
  ArchiveRpm = 27,
  ArchiveRtf = 28,
  ArchiveSqlite = 29,
  ArchiveSwf = 30,
  ArchiveTar = 31,
  ArchiveXz = 32,
  ArchiveZ = 33,
  ArchiveZip = 34,
  ArchiveZst = 35,
  AudioAac = 36,
  AudioAiff = 37,
  AudioAmr = 38,
  AudioApe = 39,
  AudioDsf = 40,
  AudioFlac = 41,
  AudioM4a = 42,
  AudioMidi = 43,
  AudioMp3 = 44,
  AudioMp4 = 45,
  AudioOgg = 46,
  AudioOpus = 47,
  AudioWav = 48,
  BookEpub = 49,
  BookMobi = 50,
  DocDoc = 51,
  DocDocx = 52,
  DocOdt = 53,
  DocPages = 54,
  FontOtf = 55,
  FontTtf = 56,
  FontWoff = 57,
  FontWoff2 = 58,
  ImageAvif = 59,
  ImageBmp = 60,
  ImageCr2 = 61,
  ImageGif = 62,
  ImageHeic = 63,
  ImageHeif = 64,
  ImageIco = 65,
  ImageJp2 = 66,
  ImageJpeg = 67,
  ImageJxl = 68,
  ImageJxr = 69,
  ImageOra = 70,
  ImagePng = 71,
  ImagePpm = 72,
  ImagePsd = 73,
  ImageQoi = 74,
  ImageStar = 75,
  ImageSvg = 76,
  ImageTif = 77,
  ImageWebp = 78,
  InodeDirectory = 79,
  InodeSymlink = 80,
  MultipartFormData = 81,
  PresentationKeynote = 82,
  PresentationOdp = 83,
  PresentationPpt = 84,
  PresentationPptx = 85,
  SpreadsheetNumbers = 86,
  SpreadsheetOds = 87,
  SpreadsheetXls = 88,
  SpreadsheetXlsx = 89,
  TextIcs = 90,
  TextCss = 91,
  TextCsv = 92,
  TextEventStream = 93,
  TextHtml = 94,
  TextJavascript = 95,
  TextPlain = 96,
  TextSh = 97,
  TextTabSeparatedValues = 98,
  TextUriList = 99,
  TextVcard = 100,
  TextXml = 101,
  VideoAvi = 102,
  VideoFlv = 103,
  VideoM4v = 104,
  VideoMkv = 105,
  VideoMov = 106,
  VideoMp4 = 107,
  VideoMpg = 108,
  VideoWebm = 109,
  VideoWmv = 110,
  DocDocm = 111,
  TextPython = 112,
  TextMarkdown = 113,
  TextRtf = 114
}
